import React from 'react'

export const useInfiniteScroll = (state, handlers) => {
  const ref = React.useRef<IntersectionObserver | null>(null)

  const { isPending, hasNextPage } = state
  const { handleOffset } = handlers

  const lastElementRef = React.useCallback(
    node => {
      if (isPending) return

      if (ref.current) ref.current.disconnect()

      ref.current = new IntersectionObserver(entries => {
        const shouldSetNextPage = entries[0].isIntersecting && hasNextPage

        if (shouldSetNextPage) {
          handleOffset()
        }
      })

      if (node) ref.current.observe(node)
    },
    [ref, handleOffset, hasNextPage, isPending],
  )

  return lastElementRef
}
